import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import SpaceFlightService from "../../../../services/reservations/SpaceFlightService";

export const REQUEST_DELETE_SPACE_FLIGHT = "REQUEST_DELETE_SPACE_FLIGHT";
export const DELETE_SPACE_FLIGHT_SUCCESS = "DELETE_SPACE_FLIGHT_SUCCESS";
export const DELETE_SPACE_FLIGHT_ERROR = "DELETE_SPACE_FLIGHT_ERROR";

function requestDeleteSpaceFlight() {
  return {
    type: REQUEST_DELETE_SPACE_FLIGHT,
  };
}

function deleteSpaceFlightSuccess(json) {
  return {
    type: DELETE_SPACE_FLIGHT_SUCCESS,
    message: json.data,
  };
}

function deleteSpaceFlightError(json) {
  return {
    type: DELETE_SPACE_FLIGHT_ERROR,
    error: json.data,
  };
}

export function deleteSpaceFlight(space_id, space_flight_id) {
  return (dispatch) => {
    dispatch(requestDeleteSpaceFlight());
    return SpaceFlightService.deleteSpaceFlight(space_id, space_flight_id).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(deleteSpaceFlightSuccess(json.data));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(deleteSpaceFlight(space_id, space_flight_id));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(deleteSpaceFlightError(json.data));
        }
      }
    );
  };
}
